import { render, staticRenderFns } from "./SecondEyes.vue?vue&type=template&id=2b26de0d"
import script from "./SecondEyes.vue?vue&type=script&lang=js"
export * from "./SecondEyes.vue?vue&type=script&lang=js"
import style0 from "./SecondEyes.vue?vue&type=style&index=0&id=2b26de0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports